"use client";
import { jsx as e } from "react/jsx-runtime";
import { ChatButtonPrimitive as o } from "@inkeep/cxkit-primitives";
import { cn as n } from "../utils.js";
const m = ({
  className: t,
  ...a
}) => /* @__PURE__ */ e(
  o.ChatButtonContainer,
  {
    className: n("fixed right-6 bottom-6  mr-[var(--removed-body-scroll-bar-size)]", t),
    ...a
  }
), c = ({
  className: t,
  ...a
}) => /* @__PURE__ */ e(
  o.ChatButton,
  {
    className: n(
      "bg-inkeep-primary-text-bold dark:bg-gray-dark-600 rounded-full px-[18px] py-3 text-white font-medium flex items-center space-x-2 shadow-2xl dark:shadow-none transition-transform ease-in-out hover:scale-110",
      t
    ),
    ...a
  }
), d = ({
  className: t,
  ...a
}) => /* @__PURE__ */ e(o.ChatButtonText, { className: n("flex items-center", t), ...a }), h = ({
  className: t,
  ...a
}) => /* @__PURE__ */ e(
  o.ChatButtonAvatarImage,
  {
    className: n(
      "data-[type=icon]:[--start-color:theme(colors.inkeep-expanded-primary.50)]",
      "data-[type=icon]:[--end-color:theme(colors.inkeep-expanded-primary.300)]",
      "h-6 w-6",
      t
    ),
    ...a
  }
), l = ({
  className: t,
  ...a
}) => /* @__PURE__ */ e(o.ChatButtonAvatarContent, { className: n("", t), ...a });
export {
  c as ChatButton,
  l as ChatButtonAvatarContent,
  h as ChatButtonAvatarImage,
  d as ChatButtonText,
  m as Container
};
